import type { FC } from 'react';

import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';

import styles from './FloatingBetControls.module.css';


export const FloatingBetMultiplier: FC = () => {
  const isMultiplier = parseFloat(useHighflyerStateSlice.getMultiplier()).toFixed(2);
  const currentStatus = useGameStateSlice.getCurrentStatus();

  const mods = useModifiers(
    styles,
    'multiplerContainer',
    {
      multiplierCrash: [GameStatus.Result].includes(currentStatus as GameStatus),
    },
    { withBaseClass: true }
  );

  return (
    isMultiplier && (
      <div className={`${mods}`}>
        {isMultiplier.split('').map((el: string) => {
          return (
            <span className={styles.mulContainerEle} data-char={el} key={el + 'mul'}>
              {el}
            </span>
          );
        })}
        <span className={styles.containerEleSuffix}>x</span>
      </div>
    )
  );
};
